// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1Lkv5","primary":"Button_primary__I_9I9","secondary":"Button_secondary__1gv5E","danger":"Button_danger__5o5di"};